/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Groupssystemjoined2Inputs */

const en_groupssystemjoined2 = /** @type {(inputs: Groupssystemjoined2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} joined`)
};

const de_groupssystemjoined2 = /** @type {(inputs: Groupssystemjoined2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} ist dabei`)
};

/**
* | output |
* | --- |
* | "{name} joined" |
*
* @param {Groupssystemjoined2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const groupssystemjoined2 = /** @type {((inputs: Groupssystemjoined2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Groupssystemjoined2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_groupssystemjoined2(inputs)
	return de_groupssystemjoined2(inputs)
});
export { groupssystemjoined2 as "groupsSystemJoined" }